<template>
  <div class="content-box">
    <div class="content-body contant-wrap">
      <el-card style="margin-bottom: 20px">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- <el-tab-pane label="对账" name="first">
            <el-form :model="form" ref="form" :rules="rule1" :inline="true">
              <el-form-item label="日期：">
                <el-date-picker
                  v-model="time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  :picker-options="pickerOptions"
                  @change="changeTime(1)"
                  style="width: 280px;"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="险种" prop="insutype">
                <el-select v-model="form.insutype" placeholder="请选择" class="input">
                  <el-option
                    v-for="item in insutypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="清算类别" prop="clr_type">
                <el-select v-model="form.clr_type" placeholder="请选择" class="input">
                  <el-option
                    v-for="item in clrtypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算经办机构" prop="setl_optins">
                <el-select v-model="form.setl_optins" placeholder="请选择" class="input">
                  <el-option
                    v-for="item in setlOptinsList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getReconciliationList(form)">查询</el-button>
                <el-button @click="reconciliation" type="primary">对总账</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="tableData" style="width: 100%;" v-loading="loading1">
              <el-table-column type="index" label="序号" align="center"></el-table-column>
              <el-table-column prop="psnName" label="人员姓名" align="center"> </el-table-column>
              <el-table-column prop="medfeeSumamt" label="医疗费用总额" align="center"> </el-table-column>
              <el-table-column prop="fundPaySumamt" label="基金支付总额" align="center"> </el-table-column>
              <el-table-column prop="acctPay" label="个人账户总额" align="center"> </el-table-column>
              <el-table-column prop="psnCashPay" label="个人现金支出" align="center"> </el-table-column>
              <el-table-column prop="balc" label="余额" align="center"> </el-table-column>
              <el-table-column prop="insutypeLabel" label="险种类型" :show-overflow-tooltip="true" align="center"> </el-table-column>
              <el-table-column prop="clrTypeLabel" label="清算类别" align="center"></el-table-column>
              <el-table-column prop="clrOptinsLabel" label="结算经办机构" align="center"> </el-table-column>
              <el-table-column prop="admdvsLabel" label="参保地" align="center"> </el-table-column>
              <el-table-column prop="setlTime" label="结算时间" align="center" width="160"> </el-table-column>
            </el-table>
            <div class="pagination" v-if="tableData.length > 0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="form.page"
                :page-sizes="pageSizes"
                :page-size.sync="form.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </el-tab-pane> -->
          
          <!-- 对账记录 -->
          <el-tab-pane label="对总账" name="second">
            <el-form :model="form2" :inline="true">
              <el-form-item label="日期：">
                <el-date-picker
                  v-model="time2"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 250px;"
                  :default-time="['00:00:00', '23:59:59']"
                  :picker-options="pickerOptions"
                  @change="changeTime(2)"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="医疗类别">
                <el-select v-model="form2.med_type" placeholder="请选择" class="input" clearable style="width: 120px;">
                  <!-- <el-option
                      v-for="item in medTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option> -->
                  <el-option label="普通门诊" :value="11"></el-option>
                  <el-option label="独立门诊部个人帐户支付" :value="9935"></el-option>
                  <el-option label="定点药店" :value="41"></el-option>
                  <el-option label="门诊慢特病" :value="12"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="险种">
                <el-select v-model="form2.insutype" placeholder="请选择" class="input" clearable>
                  <el-option
                    v-for="item in insutypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="清算类别">
                <el-select v-model="form2.clr_type" placeholder="请选择" class="input" clearable style="width: 100px;">
                  <el-option
                    v-for="item in clrtypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算经办机构">
                <el-select v-model="form2.setl_optins" placeholder="请选择" class="input" clearable>
                  <el-option
                    v-for="item in setlOptinsList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getRecord(form2)" size="small">查询</el-button>
                <el-button type="primary" @click="isReconciliationShow = true" size="small">对总账</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="recordList" style="width: 100%" v-loading="loading2">
              <el-table-column width="50px" type="index" label="序号" align="center"></el-table-column>
              <el-table-column label="账单期" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                  {{ scope.row.stmtBegndate.substring(0,10) }} ~ {{ scope.row.stmtEnddate.substring(0,10) }}
                </template>
              </el-table-column>
              <el-table-column prop="medfeeSumamt" label="医疗费用总额" align="center"> </el-table-column>
              <el-table-column prop="fundPaySumamt" label="基金支付总额" align="center"> </el-table-column>
              <el-table-column prop="acctPay" label="个人账户总额" align="center"> </el-table-column>
              <!-- <el-table-column prop="psnCashPay" label="个人现金支出" align="center"> </el-table-column> -->
              <el-table-column prop="insutypeLabel" label="险种类型" align="center"> </el-table-column>
              <el-table-column width="100px" prop="clrTypeLabel" label="清算类别" align="center"></el-table-column>
              <el-table-column width="120px" prop="setlOptinsLabel" label="结算经办机构" align="center"> </el-table-column>
              <el-table-column prop="gmtCreate" label="对账时间" :show-overflow-tooltip="true" align="center">
                <!-- <template slot-scope="scope">
                  {{ utc2Local(scope.row.gmt_create) }}
                </template> -->
              </el-table-column>
              <el-table-column prop="stmtRsltDscr" label="对账结果" align="center"> </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button @click="reconciliationDetail(scope.row)" type="text">对账/明细</el-button>
                  <!-- <el-button type="text" @click="checkDetail">明细</el-button> -->
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination" v-if="recordList.length > 0">
              <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page.sync="form2.page"
                :page-sizes="pageSizes"
                :page-size.sync="form2.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="recordTotal"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
      <!-- 对总账弹窗 -->
      <el-dialog title="对总账" :visible.sync="isReconciliationShow" width="30%">
        <el-form :model="form" ref="form" :rules="rule1" label-width="120px">
          <el-form-item label="医疗类别">
            <el-select v-model="form.med_type" clearable size="small" placeholder="请选择" style="width: 80%;">
              <!-- <el-option
                  v-for="item in medTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option> -->
              <el-option label="普通门诊" :value="11"></el-option>
              <el-option label="独立门诊部个人帐户支付" :value="9935"></el-option>
              <el-option label="定点药店" :value="41"></el-option>
              <el-option label="门诊慢特病" :value="12"></el-option>
            </el-select>
          </el-form-item>
              <el-form-item label="日期：">
                <el-date-picker
                  v-model="time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  :picker-options="pickerOptions"
                  @change="changeTime(1)"
                  style="width: 80%;"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="险种：" prop="insutype">
                <el-select v-model="form.insutype" placeholder="请选择" style="width: 80%;">
                  <el-option
                    v-for="item in insutypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="清算类别：" prop="clr_type">
                <el-select v-model="form.clr_type" placeholder="请选择" style="width: 80%;">
                  <el-option
                    v-for="item in clrtypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算经办机构：" prop="setl_optins">
                <el-select v-model="form.setl_optins" placeholder="请选择" style="width: 80%;">
                  <el-option
                    v-for="item in setlOptinsList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item >
                <el-button @click="reconciliation" type="primary" size="small">确定</el-button>
              </el-form-item>
            </el-form>
      </el-dialog>
      <!-- 查看明细弹窗 -->
      <el-dialog title="结算明细" @close="closeDialog" :visible.sync="isDetailShow" width="70%">
        <el-table v-loading="loading" :data="detailList" max-height="500">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column prop="fixmedinsCode" label="机构编号" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="psnName" label="姓名" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="psnNo" label="人员编号" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="mdtrtId" label="就诊ID" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="setlId" label="结算ID" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="msgid" label="发送方报文ID" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="setlOptins" label="结算经办机构" align="center"></el-table-column>
          <el-table-column prop="refdSetlFlag" label="退费结算标志" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.refdSetlFlag == '0' ? '否' : '是' }}
            </template>
          </el-table-column>
          <el-table-column prop="memo" label="备注"></el-table-column>
          <el-table-column prop="medfeeSumamt" label="医疗费总额" align="center"></el-table-column>
          <el-table-column prop="fundPaySumamt" label="基金支付总额" align="center"></el-table-column>
          <el-table-column prop="acctPay" label="个人账户支出" align="center"></el-table-column>
          <el-table-column prop="clrTypeLabel" label="清算类别" align="center"></el-table-column>
          <el-table-column prop="stmtBegndate" label="对账开始日期" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.stmtBegndate.substring(0,10) }}
            </template>
          </el-table-column>
          <el-table-column prop="stmtEnddate" label="对账结束日期" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.stmtEnddate.substring(0,10) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="fixmedinsSetlCnt" label="结算笔数" align="center"></el-table-column> -->
          <el-table-column prop="stmtRslt" label="对账结果" align="center">
            <template slot-scope="scope">
              {{ scope.row.stmtRslt == '0' ? '平' : '不平' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center">
           <template slot-scope="scope">
          <!--    <el-button @click="reverseTransaction(scope.row)" :disabled="scope.row.stmtRslt == 0" type="text">冲正交易</el-button>-->
              <el-button :loading="btnLoading" @click="handleCompensate(scope.row)" v-if="scope.row.stmtRslt == 1 || scope.row.stmtRslt == 101" type="text">补偿</el-button>
           </template>
          </el-table-column>
        </el-table>
        <div class="total">共{{total2}}条数据</div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { startDateWeek } from '@/utils/filter';
import { pageSizes ,pickerOptions } from "@/config/constant";
import moment from 'moment';
import Store from "@/utils/localStore/index";
import {getLastMonthFirstDateStr, getLastMonthLastDateStr} from "@/utils/util";

export default {
  name: "reconciliation",
  data() {
    return {
      pageSizes,
      pickerOptions,
      time:[],
      time2:[],
      tableData: [],
      recordList: [],
      total: 0,//对账列表总条数
      isDetailShow: false,
      isReconciliationShow:false,
      insutypeList:[],//险种列表
      medTypeOptions: [
        {
          value: '11',
          label: '普通门诊'
        }, {
          value: '41',
          label: '定点药店'
        }, {
          value: '14',
          label: '门诊慢特病'
        }
      ],
      clrtypeList:[
          {
            label:'门诊',
            value:'11'
          },
          {
            label:'定点药店',
            value:'41'
          },
          {
            label:'异地',
            value:'9901'
          }
        ],//清算类别列表
      setlOptinsList:[],//结算经办机构列表
      form:{
        limit: 20,
	      page: 1,
        insutype:'',//险种
        med_type: '', //11普通门诊, 41定点药店, 14门诊慢特病
        clr_type:'',//清算类别
        setl_optins:'',// 结算经办机构
        setl_time_start:startDateWeek()[0],
        setl_time_end:startDateWeek()[1],
        fixmedins_refd_setl_flag:'0'
      },
      rule1:{
        insutype:[{ required: true, message: '请选择险种', trigger: 'blur' }],
        clr_type:[{ required: true, message: '请选择清算类别', trigger: 'blur' }],
        setl_optins:[{ required: true, message: '请选择结算经办机构', trigger: 'blur' }],
        // setl_time_start:[{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        // setl_time_end:[{ required: true, message: '请选择结束时间', trigger: 'blur' }]
      },
      form2:{
        limit: 20,
	      page: 1,
        insutype:'',//险种
        med_type: '', //11普通门诊, 41定点药店, 14门诊慢特病
        clr_type:'',//清算类别
        setl_optins:'',// 结算经办机构
        stmt_begndate:startDateWeek()[0],
        stmt_enddate:startDateWeek()[1]
      },
      recordTotal:0,//对账记录总条数
      activeName: 'second',
      detailList:[],//明细列表
      total2:0,//明细记录总条数
      loading:false,
      loading1:false,
      loading2:false,
      detailparams:{
        insutype:'',
        clr_type:'',
        setl_optins:'',
        stmt_begndate:'',
        stmt_enddate:''
      },//用来放置对明细帐的参数
      btnLoading: false
    };
  },
  mounted(){
    this.initReconciliationList()
    this.getRecord(this.form2)
    // this.time = startDateWeek()
    this.time = [getLastMonthFirstDateStr(), getLastMonthLastDateStr()]
    this.time2 = startDateWeek()
    console.log(this.countInfo)
  },
  computed: {
    countInfo () {
      return this.$store.state.global.countInfo
    },
  },
  methods: {
    // 补偿
    handleCompensate(row) {
      let that = this
      let obj = {
        id: row.id,
        psnNo: row.psnNo,
        setlId: row.setlId,
        mdtrtId: row.mdtrtId
      }
      this.btnLoading = true
      this.$api.newInsurance.getCompensate(obj).then((res) => {
        this.$message({
          type:'warning',
          message: res.data.message
        })
        that.closeDialog()
        that.btnLoading = false
      })
    },
    utc2Local(utc){
      return moment.utc(utc).local().format('YYYY-MM-DD HH:mm:ss')
    },
    handleClick(tab, event) {
      // console.log(tab, 'tab');
      if (tab.label == '对账') {
        // console.log('对账');
        this.getReconciliationList(this.form)
      }else if (tab.label == '对账记录') {
        // console.log('对账记录');
        this.getRecord(this.form2)
      }
    },
    changeTime(type){
      // console.log(type,'3333')
      if(type == 1 && this.time){
        // this.form.setl_time_start = this.time[0]
        // this.form.setl_time_end = this.time[1]
        this.form.setl_time_start = null
        this.form.setl_time_end = null
      }else if(type == 2 && this.time2){
        // this.form2.stmt_begndate = this.time2[0]
        // this.form2.stmt_enddate = this.time2[1]
        this.form2.stmt_begndate = null
        this.form2.stmt_enddate = null
      }
    },
    checkDetail() {
      this.isDetailShow = true;
    },
    async getinsutypeList(){
      const res = await this.$api.newInsurance.getDictionaryByClinicAPI({type:'INSUTYPE'})
      if (res.data.code == 200 && res.data.data!=null) {
        this.insutypeList = res.data.data
        const flag = this.insutypeList.some(item => {
          return item.value == '310'
        })
        if (flag) {
          // this.form.insutype = '310'
          // this.form2.insutype = '310'
          this.form.insutype = null
          this.form2.insutype = null
        }else{
          // this.form.insutype = this.insutypeList[0].value
          // this.form2.insutype = this.insutypeList[0].value
          this.form.insutype = null
          this.form2.insutype = null
        }
      }else{
        this.insutypeList = [
          {
            label:'职工基本医疗保险',
            value:'310'
          }
        ]
        // this.form.insutype = '310'
        // this.form2.insutype = '310'
        this.form.insutype = null
        this.form2.insutype = null
      }
    },
    async getclrtypeList(){
      const res = await this.$api.newInsurance.getDictionaryByClinicAPI({type:'CLR_TYPE'})
      if (res.data.code == 200 && res.data.data!=null) {
        this.clrtypeList = res.data.data
        const flag = this.clrtypeList.some(item => {
          return item.value == '11'
        })
        if (flag) {
          // this.form.clr_type = '11'
          // this.form2.clr_type = '11'
          this.form.clr_type = null
          this.form2.clr_type = null
        }else{
          // this.form.clr_type = this.clrtypeList[0].value
          // this.form2.clr_type = this.clrtypeList[0].value
          this.form.clr_type = null
          this.form2.clr_type = null
        }
      }else{
        this.clrtypeList = [
          {
            label:'门诊',
            value:'11'
          }
        ]
        // this.form.clr_type = '11'
        // this.form2.clr_type = '11'
        this.form.clr_type = null
        this.form2.clr_type = null
      }
    },
    // 获取经办机构
    async getSetlOptins(){
      const res = await this.$api.newInsurance.getDictionaryByClinicAPI({type:'ADMDVS'})
      if (res.data.code == 200 && res.data.data != null) {
        this.setlOptinsList = res.data.data
        const { fixMedIns } = Store.get('vuex').global.countInfo
        const flag = this.setlOptinsList.some(item => {
          return item.value == fixMedIns.mdtrtareaAdmvs
        })
        if (flag) {
          // this.form.setl_optins = fixMedIns.mdtrtareaAdmvs
          // this.form2.setl_optins = fixMedIns.mdtrtareaAdmvs
          this.form.setl_optins = null
          this.form2.setl_optins = null
        }else{
          // this.form.setl_optins = this.setlOptinsList[0].value
          // this.form2.setl_optins = this.setlOptinsList[0].value
          this.form.setl_optins = null
          this.form2.setl_optins = null
        }
      }else{
        this.setlOptinsList = [
          {
            label:fixMedIns.mdtrtareaLabel,
            value:fixMedIns.mdtrtareaAdmvs
          }
        ]
        // this.form.setl_optins = fixMedIns.mdtrtareaAdmvs
        // this.form2.setl_optins = fixMedIns.mdtrtareaAdmvs
        this.form.setl_optins = null
        this.form2.setl_optins = null
      }
      
     
    },
    // 获取对账列表
    getReconciliationList(obj){
      this.loading1 = true
      this.$refs.form.validate((valid) => {
          if (valid) {
            this.$api.newInsurance.getReconciliationListAPI(obj).then(res => {
              // console.log(res,'对账列表');
              this.loading1 = false
              if (res.data.code == 200 && res.data.data!=null) {
                const {data} = res.data
                this.tableData = data.records
                this.total = data.total
              }else{
                this.$message({
                  type:'error',
                  message:res.data.message
                })
              }
            })
          } else {
            // console.log('error submit!!');
            return false;
          }
        })
    },
    // 判断是否选择了险种、清算类别、结算经办机构
    async determine(){
      if(this.insutypeList.length > 0 && this.clrtypeList.length > 0 && this.setlOptinsList.length > 0){
        this.form.insutype = this.insutypeList[0].value
        this.form.clr_type = this.clrtypeList[0].value
        this.form.setl_optins = this.setlOptinsList[0].value
        await this.getReconciliationList(this.form)
      }else{
        this.$message({
          type:'warning',
          message:'请选择险种、清算类别、结算经办机构'
        })
      }
    },
    // 初始化对账列表
    async initReconciliationList(){
      await Promise.all([
        this.getinsutypeList(),
        // this.getclrtypeList(),
        this.getSetlOptins()
      ])
      // await this.determine()
    },
    handleSizeChange(val) {
      this.form.limit = val
      this.getReconciliationList(this.form)
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getReconciliationList(this.form)
    },
    handleSizeChange2(val) {
      this.form2.limit = val
      this.getRecord(this.form2)
    },
    handleCurrentChange2(val) {
      this.form2.page = val
      this.getRecord(this.form2)
    },
    // 对总账
    reconciliation(){
      if (!this.time) {
            this.$message({
              type:'warning',
              message:'请选择日期'
            })
            return false
          }
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            med_type:this.form.med_type,//医疗类别
            insutype:this.form.insutype,//险种
            clr_type:this.form.clr_type,//清算类别
            setl_optins:this.form.setl_optins,// 结算经办机构
            stmt_begndate:this.time && this.time[0] || null,
            stmt_enddate:this.time && this.time[1] || null
            // stmt_begndate:this.form.setl_time_start,
            // stmt_enddate:this.form.setl_time_end
          }
          this.$api.newInsurance.reconciliationAPI(params).then(res => {
            // console.log(res,'对总账');
            if(res.data.code == 200){
              this.$message({
                type:'success',
                message:res.data.message
              })
              this.isReconciliationShow = false
              this.getRecord(this.form2)
            }else{
              this.$message({
                type:'error',
                message:res.data.message
              })
            }
          })
        } else {
          return false;
        }
      })
      
    },
    // 获取对账记录
    getRecord(obj){
      this.loading2 = true
      this.$api.newInsurance.getReconciliationRecordAPI(obj).then(res => {
        // console.log(res,'对账记录');
        const {data} = res.data
        this.recordList = data.records
        this.loading2 = false
        this.recordTotal = data.total
      })
    },
    // 对明细账
    reconciliationDetail(item){
      this.isDetailShow = true
      this.loading = true
      // console.log(item,'item');
      // const params = {
      //   insutype:item.insutype,
      //   clr_type:item.clrType,
      //   setl_optins:item.setlOptins,
      //   stmt_begndate:item.stmtBegndate.substring(0,10) + ' 00:00:00',
      //   stmt_enddate:item.stmtEnddate.substring(0,10) + ' 23:59:59'
      // }
       this.detailparams = {
        insutype:item.insutype,
        clr_type:item.clrType,
        setl_optins:item.setlOptins,
        stmt_begndate:item.stmtBegndate.substring(0,10) + ' 00:00:00',
        stmt_enddate:item.stmtEnddate.substring(0,10) + ' 23:59:59'
      }
      this.$api.newInsurance.reconciliationDetailAPI(this.detailparams).then(res => {
        // console.log(res,'对明细账');
        if (res.data.code == 200 && res.data.data!=null) {
          this.detailList = res.data.data
          this.total2 = res.data.data.length
        }else{
          this.$message({
            type:'warning',
            message:res.data.message
          })
        }
        this.loading = false
      })
    },
    // 冲正交易
    reverseTransaction(item){
      // console.log(this.detailparams,'this.detailparams');
      const params = {
        psn_no:item.psnNo,
        omsgid:item.msgid,
        setl_id:item.setlId,
        mdtrt_id:item.mdtrtId
      }
      this.$api.newInsurance.reverseTransactionAPI(params).then(res => {
        // console.log(res,'冲正交易');
        if (res.data.code == 200) {
          this.$message({
            type:'success',
            message:'冲正交易成功'
          })
          this.loading = true
          // 冲正交易完成后重新获取列表
          this.$api.newInsurance.reconciliationDetailAPI(this.detailparams).then(res => {
            // console.log(res,'对明细账');
            this.detailList = res.data.data
            this.total2 = res.data.data.length
            this.loading = false
          })
        }else {
          this.$message({
            type:'error',
            message:'冲正交易失败'
          })
        }
      })  
    },
    closeDialog(){
      this.detailparams = {
        insutype:'',
        clr_type:'',
        setl_optins:'',
        stmt_begndate:'',
        stmt_enddate:''
      }
      // console.log(this.detailparams,'关闭弹窗时this.detailparams');
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-loading-spinner {
  top: 80px;
}
.total {
  text-align: center;
  margin-top: 20px;
}
.input{
  width: 180px;
}
</style>